// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"5c9bfaa6","216":"d6f21d54","274":"18de52ca","336":"02d890a0","389":"41ed7f3f","437":"432a36c5","479":"f244bea6","883":"f1d2bbd2"}[chunkId] + ".chunk.js";
};